module.exports = __webpack_public_path__ + "static/media/id_card_serial_number_en@2x.b843e93d.png";